import { ValidatorFn } from '@angular/forms/forms';

export class FormField<T> {
    value: T;
    key: string;
    label: string;
    desriptionText: string;
    order: number;
    controlType: string;
    placeholder: string;
    cssClasses: string;
    maxlength: number;
    errorMessageRequired: string;
    errorMessageValid: string;
    validators: ValidatorFn | ValidatorFn[];
    isExtraField: boolean;
    rows: number;

    constructor(options: {
        value?: T,
        key?: string,
        label?: string,
        desriptionText?: string,
        order?: number,
        controlType?: string,
        placeholder?: string,
        cssClasses?: string,
        maxlength?: number,
        errorMessageRequired?: string,
        errorMessageValid?: string,
        validators?: ValidatorFn | ValidatorFn[],
        isExtraField?: boolean,
        rows?: number
      } = {}) {
      this.value = options.value;
      this.key = options.key || '';
      this.label = options.label || '';
      this.desriptionText = options.desriptionText || '';
      this.order = options.order === undefined ? 1 : options.order;
      this.controlType = options.controlType || '';
      this.placeholder = options.placeholder || '';
      this.cssClasses = options.cssClasses || '';
      this.maxlength = options.maxlength || null;
      this.errorMessageRequired = options.errorMessageRequired || '';
      this.errorMessageValid = options.errorMessageValid || '';
      this.validators = options.validators || null;
      this.isExtraField = options.isExtraField || false;
      this.rows = options.rows || null;
    }
  }
